import React, { Fragment, useEffect, useReducer, useState } from 'react'
import { PickingValidateStart } from '../../components/PickingValidate/PickingValidateStart'
import { PickingValidateRoute } from '../../components/PickingValidate/PickingValidateRoute'
import { apiCall, ApiConfig } from '../../config/api'
import {
  reducerInitialState,
  pickingValidateReducer
} from '../../components/PickingValidate/PickingValidateReducer'
import {
  setPickingRouteIdAction,
  setMessageStatus,
  setMessageColor,
  setSwitchSnackBar,
  setSwitchModal,
  setRowsPickingRouteValidate,
  setLoadingPrint,
  setPickingValidatePDF,
  changePage,
  changePageSize,
  setTotalItems,
  setIsLoadingGrid,
  setLoadingButton
} from '../../components/PickingValidate/PickingValidateAction'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { PickingValidateFinish } from '../../components/PickingValidate/PickingFinish/PickingValidateFinish'
import { TicketInfo } from '../../interfaces/PickingValidate/TicketInfo'
import { StatesRoutes } from '../../interfaces/PickingValidate/StatesRoutes'
import { PickingValidateTicket } from '../../components/PickingValidate/PickingFinish/PickingValidateTicket'
import { PickingService } from '../../redux/services/pickingService'
import { Loading } from '../../components/UI'
import { Box, Button, Typography } from '@mui/material'
import { useConfirmsAction } from '../../hooks/useConfirmAction'
import { PickingValidateHeader } from '../../interfaces/Picking/Picking'
import { AxiosResponse } from 'axios'
import { useUser } from '../../hooks/useUser'
import { useConfiguration } from '../../hooks/useConfiguration'
import { PickingRouteRelated } from '../../components/PickingValidate/PickingRoutesRelated/PickingRouteRelated'

interface PickingValidatePageProps {}

interface SnackbarState {
  open: boolean
  message: string
  status: string
}

const EnumValidateStep = {
  ComponentLoaded: 1,
  Start: 2,
  ValidateRoute: 3,
  FetchTicket: 4,
  ValidateFinish: 5,
  PrintTicket: 6,
  PrintValidation: 7
}

export const PickingValidatePage: React.FC<PickingValidatePageProps> = () => {
  const {
    userDataState: { userData },
    getUserData
  } = useUser()

  const serviceError = (message: string): void => {
    setIsLoading(false)
    MostrarMensajeConfirmacion(`Error en operación: ${message}`, 'error')
  }

  const [isUsingExternalCourierLabel, setUsingExternalCourierLabel] =
    useState(false)

  const [hasMultipleUnvalidatedRoutes, sethasMultipleUnvalidatedRoutes] =
    useState(false)

  const [isUsingInternalCourierLabel, setUsingInternalCourierLabel] =
    useState(false)
  const [isPickingRouteGroupedValidation, setIsPickingRouteGroupedValidation] =
    useState(false)

  // indica si la ruta es con una OT mono pedido. si es true muestra grilla y realiza validaciones
  const [isSingleOrderOT, setSingleOrderOT] = useState(false)

  const [isLoading, setIsLoading] = useState<boolean>(false)
  // label
  const [showButtonLabelCourier, setshowButtonLabelCourier] =
    useState<boolean>(false) // variable que se pasa por parametro al componente hijo que tiene toda la logica del boton.

  const [executeGetLabelCourier, setExecuteGetLabelCourier] =
    useState<boolean>(false) // variable que se pasa por parametro al componente hijo para traer desde etiqueta courier
  const [pickingRouteFinalized, setPickingRouteFinalized] =
    useState<boolean>(false)
  const [sorters, setSorters] = useState<any[]>([])
  const [pickingHeader, setPickingHeader] = useState<PickingValidateHeader>()
  const [btnFilter, setBtnFilter] = useState<string>('')
  const [skuId, setSkuId] = useState<string>('')
  const [step, setStep] = useState<number>(EnumValidateStep.Start)
  const [ticketInfo, setTicketInfo] = useState<TicketInfo>(new TicketInfo())
  const [pickingService] = useState<PickingService>(
    new PickingService(serviceError)
  )
  const { isLoadingConfirm, setLoadingConfirm } = useConfirmsAction()
  const [state, dispatch] = useReducer(
    pickingValidateReducer,
    reducerInitialState
  )

  const [stateSnack, setStateSnack] = useState<SnackbarState>({
    open: false,
    message: '',
    status: ''
  })

  const [statesRoute, setStatesRoute] = useState<StatesRoutes>({
    pickingRouteState: '',
    validationFinished: false,
    colorPickingRouteState: '',
    colorValidationStatus: ''
  })

  const { open, message, status } = stateSnack

  const {
    pickingRouteId,
    rows,
    isLoadingGrid,
    isLoadingPrint,
    pickingValidatePDF,
    page,
    totalItems,
    rowsPerPage,
    isLoadingButton
  } = state

  const { configurationState, getConfiguration } = useConfiguration()

  useEffect(() => {
    if (
      configurationState === undefined ||
      configurationState?.configuration.length === 0
    ) {
      getConfiguration()
    } else {
      const externalCourierLabelConfiguration =
        configurationState.configuration.filter(
          (el) => el.name === 'ExternalCourierLabel'
        )[0]

      if (externalCourierLabelConfiguration !== undefined) {
        setUsingExternalCourierLabel(
          externalCourierLabelConfiguration.value === 'true'
        )
      }

      const internalCourierLabelConfiguration =
        configurationState.configuration.filter(
          (el) => el.name === 'InternalCourierLabel'
        )[0]

      if (internalCourierLabelConfiguration !== undefined) {
        setUsingInternalCourierLabel(
          internalCourierLabelConfiguration.value === 'true'
        )
      }

      const isPickingRouteGroupedValidation =
        configurationState.configuration.filter(
          (el) => el.name === 'PickingRouteGroupedValidation'
        )[0]

      if (isPickingRouteGroupedValidation !== undefined) {
        setIsPickingRouteGroupedValidation(
          isPickingRouteGroupedValidation.value === 'true'
        )
      }
    }
  }, [configurationState])

  const handleOpen = (isOpen: boolean) => {
    setStateSnack((prevState) => ({ ...prevState, open: isOpen }))
  }

  const handleSnackBar = (isOpen: boolean, message: string, status: string) => {
    setStateSnack({
      open: isOpen,
      message,
      status
    })
  }

  const MostrarMensajeConfirmacion = (mensaje: string, tipoMensaje: any) => {
    dispatch(setMessageStatus(mensaje))
    dispatch(setMessageColor(tipoMensaje))
    dispatch(setSwitchSnackBar(true))
    dispatch(setSwitchModal(false))
  }

  const handlePageChange = (updatePage: number) => {
    dispatch(changePage(updatePage))
  }

  const handlePageSizeChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const newPageSize = event.target.value as number
    dispatch(changePage(0))
    dispatch(changePageSize(newPageSize))
  }

  const handleOnChangeFilter = (e: any) => {
    setSkuId(e.target.value)
  }

  const handleOnClickSorter = (name: string, sorter: string) => {
    setSorters([
      {
        key: name,
        value: sorter
      }
    ])
  }

  const handleShowLabelButton = (value: boolean) => {
    setshowButtonLabelCourier(value)
  }
  const handleStatusFilter = (btnFilter: string) => {
    const arrayBtnFilter = btnFilter.split('-')

    const strButtonFilter: string =
      arrayBtnFilter.length > 0
        ? `&Status=${arrayBtnFilter.join('&Status=')}`
        : ''

    return strButtonFilter
  }

  const handleSorterFilter = () => {
    if (sorters.length > 0) {
      let strSorterFilter: string = ''
      const sorterFilter = sorters.map(({ value }) => `filter=${value}`)

      strSorterFilter =
        sorterFilter.length > 0 ? `&${sorterFilter.join('&')}` : ''

      return strSorterFilter
    } else {
      return ''
    }
  }

  const handleSkuFilter = () => {
    let SkuId: string = ''
    if (skuId !== '') {
      SkuId = `&Sku=${skuId}`
    } else {
      SkuId = ''
    }
    return SkuId
  }

  useEffect(() => {
    if (step === EnumValidateStep.FetchTicket) {
      async function fetchData() {
        const ticket = await pickingService.getTicketInfo(pickingRouteId)
        if (ticket) {
          setIsLoading(false)
          setTicketInfo(ticket)
          setStep(EnumValidateStep.ValidateFinish)
        } else {
          MostrarMensajeConfirmacion('Error al cargar los datos', 'error')
          setStep(EnumValidateStep.Start)
        }
      }
      fetchData()
    }
  }, [step])

  useEffect(() => {
    if (pickingRouteId > 0) {
      // Añadir un pequeño delay para evitar llamadas múltiples cuando se cambia pageSize y page juntos
      const timeoutId = setTimeout(() => {
        handleStartPickingRoute('pickingRouteId', pickingRouteId.toString())
      }, 50)
      return () => clearTimeout(timeoutId)
    }
    return undefined
  }, [btnFilter, page, rowsPerPage, skuId, sorters])

  const [
    selectedFieldForSearchPickingRoute,
    setSelectedFieldForSearchPickingRoute
  ] = useState('pickingRouteId')

  const [
    selectedValueForSearchPickingRoute,
    setSelectedValueForSearchPickingRoute
  ] = useState('')

  useEffect(() => {
    getUserData()
  }, [])

  const handleStartPickingRoute = (field?: string, value?: string) => {
    //  validamos que el usuario haya sido encontrado en WMS
    if (!userData) {
      handleSnackBar(
        true,
        'Usuario no ha sido detectado en el sistema',
        'error'
      )
    } else {
      dispatch(setLoadingButton(true))
      dispatch(setIsLoadingGrid(true))
      let strBtnFilter: string = ''
      let strSorterFilter: string = ''
      let SkuFilter: string = ''

      if (btnFilter.length > 0) {
        strBtnFilter = handleStatusFilter(btnFilter)
      }

      if (sorters.length > 0) {
        strSorterFilter = handleSorterFilter()
      }

      SkuFilter = handleSkuFilter()
      setTimeout(() => {
        apiCall(
          'GET',
          `${
            ApiConfig.PickingRouteValidationApi
          }/GetPickingRouteValidationDetail?${
            field || selectedFieldForSearchPickingRoute
          }=${
            value || selectedValueForSearchPickingRoute
          }&UserId=${userData?.userId!}${
            SkuFilter === '' ? '&PageIndex=' + page : ''
          }${
            SkuFilter === '' ? '&PageSize=' + rowsPerPage : ''
          }${strBtnFilter}${strSorterFilter}${SkuFilter}`
        )
          .then((response) => {
            if (response.data.success === true && response.data.data !== null) {
              if (
                response.data.data.validationFinished ||
                response.data.data.pickingRouteState !== 'FINALIZADA'
              ) {
                setStatesRoute({
                  pickingRouteState: response.data.data.pickingRouteState,
                  validationFinished: response.data.data.validationFinished,
                  colorPickingRouteState:
                    response.data.data.colorPickingRouteState,
                  colorValidationStatus:
                    response.data.data.colorValidationStatus
                })

                dispatch(
                  setPickingRouteIdAction(response.data.data.pickingRouteId)
                )
                setStep(EnumValidateStep.FetchTicket)
                setPickingHeader(response.data.data)
                setPickingRouteFinalized(false)
              } else {
                setPickingRouteFinalized(true)
                dispatch(
                  setPickingRouteIdAction(response.data.data.pickingRouteId)
                )
                setPickingHeader(response.data.data)
                dispatch(
                  setRowsPickingRouteValidate(response.data.data.skuDetail)
                )
                dispatch(setTotalItems(
                  SkuFilter !== ''
                    ? response.data.data.skuDetail.length
                    : response.data.data.totalSku
                ))
                SkuFilter !== '' && dispatch(changePage(0))
                setStep(EnumValidateStep.ValidateRoute)
              }
            } else {
              handleSnackBar(true, response.data.message.toString(), 'error')
            }
            dispatch(setLoadingButton(false))
            dispatch(setIsLoadingGrid(false))
          })
          .catch(
            ({
              data: {
                data: { message }
              }
            }) => {
              handleSnackBar(true, message.toString(), 'error')
            }
          )
      }, 500)
    }
  }

  const handlePrintPickingRouteValidate = () => {
    dispatch(setLoadingPrint(true))
    apiCall(
      'GET',
      `${ApiConfig.PickingRouteValidationApi}/GetValidationReport/${pickingRouteId}`
    )
      .then((response) => {
        if (response.status === 200 && response.data !== null) {
          dispatch(setLoadingPrint(false))
          dispatch(setPickingValidatePDF(response.data))
        }
      })
      .catch((error) => {
        dispatch(setPickingValidatePDF(''))
        console.log(error)
      })
  }

  const handlePrintTicket = (ticketInfo: TicketInfo) => {
    setTicketInfo(ticketInfo)
    setStep(EnumValidateStep.PrintTicket)
  }

  const handleStepBack = () => {
    setStep(EnumValidateStep.Start)
    dispatch(setPickingRouteIdAction(0))
    setSkuId('')
    setBtnFilter('')
    setSorters([])
  }

  const handleClosePickingRouteValidate = () => {
    setIsLoading(true)
    setLoadingConfirm(true)
    apiCall(
      'POST',
      `${ApiConfig.PickingRouteValidationApi}/ClosePickingRouteValidation`,
      {
        PickingRouteId: pickingRouteId,
        UserId: userData?.userId!
      }
    )
      .then((axiosResponse: AxiosResponse) => {
        const apiResponse = axiosResponse.data
        if (apiResponse.success) {
          handleStartPickingRoute('pickingRouteId', pickingRouteId.toString())
        } else {
          handleSnackBar(true, apiResponse.message.toString(), 'error')
          MostrarMensajeConfirmacion(apiResponse.message, 'error')
        }
        setIsLoading(false)
        setLoadingConfirm(false)
      })
      .catch((error) => {
        setIsLoading(false)
        setLoadingConfirm(false)
        handleSnackBar(
          true,
          'Error en la operación: se produjo una falla en el servicio.',
          'error'
        )
        MostrarMensajeConfirmacion(
          'Error en la operación: se produjo una falla en el servicio.',
          'error'
        )
        console.log(error)
      })
  }

  const handleClearAndFindRoute = (field?: string, value?: string) => {
    setSelectedValueForSearchPickingRoute(value || '')
    dispatch(setPickingRouteIdAction(0))
    setSkuId('')
    setBtnFilter('')
    setSorters([])
    handleStartPickingRoute(field, value)
  }

  return (
    <Fragment>
      {step !== EnumValidateStep.Start && (
        <Fragment>
          <Box display='flex' justifyContent='space-between' p={2}>
            <Button
              variant='contained'
              color='primary'
              onClick={handleStepBack}
            >
              VALIDAR OTRA RUTA
            </Button>
            {showButtonLabelCourier && (
              <Box display='flex' alignItems='center'>
                <Typography
                  variant='h6'
                  style={{ marginRight: 8, fontWeight: 'bold' }}
                >
                  ETIQUETA TRANSPORTISTA
                </Typography>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    setExecuteGetLabelCourier(!executeGetLabelCourier)
                  }}
                >
                  IMPRIMIR
                </Button>
              </Box>
            )}
          </Box>
        </Fragment>
      )}
      {isLoading && <Loading />}
      {step === EnumValidateStep.Start && (
        <PickingValidateStart
          handleStartPickingRoute={handleStartPickingRoute}
          pickingRouteId={pickingRouteId}
          isLoadingButton={isLoadingButton}
          handlePagination={handlePageChange}
          handleSelectedField={setSelectedFieldForSearchPickingRoute}
          selectedField={selectedFieldForSearchPickingRoute}
          handleSelectedValue={setSelectedValueForSearchPickingRoute}
          selectedValue={selectedValueForSearchPickingRoute}
          handleSnackBar={handleSnackBar}
          setSingleOrderOT={setSingleOrderOT}
        />
      )}
      {step === EnumValidateStep.ValidateRoute && (
        <PickingValidateRoute
          rows={rows}
          isLoadingGrid={isLoadingGrid}
          handleOnChangeFilter={handleOnChangeFilter}
          handleStartPickingRoute={handleStartPickingRoute}
          handleOnClickSorter={handleOnClickSorter}
          setBtnFilter={setBtnFilter}
          btnFilter={btnFilter}
          sorters={sorters}
          handlePrintPickingRouteValidate={handlePrintPickingRouteValidate}
          isLoadingPrint={isLoadingPrint}
          pickingValidatePDF={pickingValidatePDF}
          pickingRouteId={pickingRouteId}
          page={page}
          totalItems={totalItems}
          pageSize={rowsPerPage}
          handlePageSize={handlePageSizeChange}
          handlePagination={handlePageChange}
          handleClosePickingRouteValidate={handleClosePickingRouteValidate}
          isLoadingConfirm={isLoadingConfirm}
          skuId={skuId}
          setSkuId={setSkuId}
          pickingHeader={pickingHeader!}
          isPickingRouteGroupedValidation={isPickingRouteGroupedValidation}
        />
      )}
      {step === EnumValidateStep.ValidateFinish && (
        <Fragment>
          {/* si es Ot mono pedido */}
          {isSingleOrderOT && (
            <PickingRouteRelated
              hasMultipleUnvalidatedRoutes={hasMultipleUnvalidatedRoutes}
              pickingRouteId={pickingRouteId}
              handleStartPickingRoute={handleClearAndFindRoute}
              handlePageChange={handlePageChange}
              PickingRouteStateFindedValidated={pickingRouteFinalized}
            />
          )}

          <PickingValidateFinish
            sethasMultipleUnvalidatedRoutes={sethasMultipleUnvalidatedRoutes}
            ticketInfo={ticketInfo}
            handlePrintTicket={handlePrintTicket}
            statesRoute={statesRoute}
            isUsingExternalCourierLabel={isUsingExternalCourierLabel}
            isUsingInternalCourierLabel={isUsingInternalCourierLabel}
            pickingHeader={pickingHeader}
            handleShowLabelButton={handleShowLabelButton}
            executeGetLabelCourier={executeGetLabelCourier}
          />
        </Fragment>
      )}
      {step === EnumValidateStep.PrintTicket && (
        <PickingValidateTicket ticketInfo={ticketInfo}></PickingValidateTicket>
      )}
      <SnackBar
        open={open}
        setOpen={handleOpen}
        message={message}
        status={status}
      />
    </Fragment>
  )
}
